import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { withAppContext } from '../../contexts/AppContext.js';

class PopupContent extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
        show: false,
        content: {},
    };

    this.appRef = this.props.appContext.appRef;
  }

  show(content) {
    this.setState({show: true, content: content});
  }

  hide() {
    this.setState({show: false, content: {}});
  }

  render() { 
    const {show, content } = this.state;

    const is_signed = this.appRef.current.get_is_signed();

    if (show)
    {
      return <div className={`container page_content popup ${is_signed ? 'signed' : 'unsigned'}`}>
      <div className="content">
        <PageHeader parent_ref={this} />
        
        <div className='container_inner'>
          <h1 className="page_title">{content.title}</h1>
          <div className="page_content" dangerouslySetInnerHTML={{__html: content.content}}></div>
        </div>
      </div>
    </div>;
    }
    else {
      return ''; 
    }
  }
}

export default withAppContext(PopupContent);